var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"flex items-center",attrs:{"href":_vm.$enums.AppLinks.TERMS_AND_CONDITIONS,"target":"_blank"}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.$t('$General.TermsAndConditions'))+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }